<script>
import IMask from 'imask';
import { IMaskDirective } from 'vue-imask';
import Field from './field.vue';

export default {
  directives: {
    mask: IMaskDirective,
  },
  extends: Field,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    mask: {
      type: null,
      default: undefined,
    },
    sizeLimit: {
      type: Number,
      default: 5 * 1024 * 1024,
    },
  },
  data() {
    return {
      complete: true,
      maskedValue: this.value,
    };
  },
  computed: {
    isValid() {
      return Boolean(
        // computed parent validation
        this.valid &&
          // mask completion
          this.complete &&
          // has value if required
          (!this.required || this.model) &&
          // not invalidated without memory
          !this.errorStatus &&
          // not valid by rules
          !this.errorElement
      );
    },

    imask() {
      return this.mask && !process.server ? IMask.createMask(this.mask) : undefined;
    },

    validatorContext() {
      return {
        value: this.model,
        secondValue: this.secondValue,
        errorStatus: this.errorStatus,
        valid: this.valid,
        complete: this.complete,
      };
    },
  },
  methods: {
    setValue(value) {
      if (this.maskedValue === value || this.model === value) return;
      this.maskedValue = value;

      if (this.imask) {
        this.imask.resolve(value);
        this.model = this.imask.unmaskedValue;
      } else {
        this.model = value;
      }
      this.$emit('input', this.model);
    },

    // When dealing with masked input, update value manually
    updateMask(event) {
      // Always use unmasked value
      this.setValue(event.detail.value);
      // Set complete to false as MAY not be finished
      this.complete = false;
    },

    // When dealing with masked input, track when mask is completed
    completeMask() {
      // Set complete to true if mask is completed
      // This always triggers after this.updateMask
      this.complete = true;
    },

    /** Toggle password visibility */
    toggleType() {
      this.visible = !this.visible;
    },
  },
  render(h) {
    return h(
      'div',
      {
        class: [
          'sf-input',
          {
            focused: this.focused,
            valid: this.isValid && this.isDirty && !this.disabled,
            invalid: this.showError && !this.disabled,
            disabled: this.disabled || this.form.loading,
            active: this.active,
          },
        ],
      },
      [
        h('label', { class: 'sf-input__container' }, [
          h('div', { class: 'sf-input__label' }, this.label),
          h('input', {
            ref: 'element',
            domProps: {
              value: this.imask ? this.maskedValue : this.model,
            },
            directives: this.imask ? [{ name: 'mask', value: this.mask }] : [],
            attrs: {
              type: this.type === 'password' && this.visible ? 'text' : this.type,
              ...this.$attrs,
            },
            on: {
              focus: this.onFocus,
              blur: this.onBlur,
              paste: () => {
                this.behaviourCapture.pasted = true;
              },
              ...(this.imask
                ? {
                    accept: this.updateMask,
                    complete: this.completeMask,
                  }
                : {
                    input: event =>
                      this.type === 'file'
                        ? this.setFiles(event.target.files)
                        : this.setValue(event.target.value),
                  }),
            },
          }),
          h(
            'div',
            { class: 'sf-input__icon' },
            this.$slots.icon || [
              this.type === 'password'
                ? h('div', {
                    class: ['sf-input__toggle', { crossed: !this.visible }],
                    on: {
                      click: this.toggleType,
                    },
                  })
                : h('div', { class: 'sf-input__indicator' }),
            ]
          ),
        ]),
        h(
          'transition',
          {
            props: { name: 'v-fade' },
          },
          [
            h(
              'div',
              {
                class: 'sf-tooltip',
                directives: [
                  {
                    name: 'show',
                    value: this.showTooltip,
                  },
                ],
              },
              this.tooltip
            ),
          ]
        ),
        h(
          'div',
          {
            class: ['sf-error', { active: this.showError }],
            directives: [
              {
                name: 'qa',
                value: this.errorElement.selector,
              },
            ],
          },
          this.errorElement.message
        ),
      ]
    );
  },
};
</script>
